import { MijnRoute } from '../mijn-navigatie.model';

export const WIJZIGEN_AFSCHRIFTFREQUENTIE: MijnRoute = {
    path: 'wijzigen-afschriftfrequentie',
    navigationEvent: 'toWijzigenAfschriftfrequentie',
    regex: /^\/wijzigen-afschriftfrequentie$/,
    webcomponent: 'mijn-wijzigen-afschriftfrequentie-webcomponent'
};
